import {ImageRequestParams} from "../models/image/image-request-params";

export class UserEditImageRequestParams extends ImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `bolao26/Icons/User_Edit_Icon`;
    this.ratio = 3;
  }
}
